/* jshint node:true */
'use strict';

var debug   = require('debug')('app:action:loadHome');
var apiHost = require('../helpers/utils/apiHost.js');

module.exports = function(context, payload, done) {

    debug('loading home %s', JSON.stringify([payload]));
    var sAPIHost    = apiHost.get(payload);

    context.service.get({
        url : sAPIHost+'/apis/v2/flex?headlinestack=true&insider=false&pubkey=espnuk-en-rugby-index',
        done : function(data) {
            context.dispatch('RECEIVED_HOME', data);
            done();
        }
    });
};



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/actions/loadHome.js
 **/